// Base dinámica al mismo host donde está desplegado el front:
const baseURL = `${window.location.origin}/`; 
export default baseURL;
